module Meevo.Plugins.PaymentPlans {
    export class PaymentPlansHelper {

        static factory(): Function {
            const instance = ($translate: ng.translate.ITranslateService) => {
                return new PaymentPlansHelper($translate);
            };

            instance.$inject = [
                '$translate'
            ];

            return instance;
        }

        constructor(private _$translate: ng.translate.ITranslateService) {
        }

        payPlanPaymentStatusVerbose(input: Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum): string {
            switch (input) {
                case Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum.Error:
                    return this._$translate.instant('LABEL_ERROR');
                case Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum.NotBilled:
                    return this._$translate.instant('LABEL_NOT_BILLED');
                case Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum.Paid:
                    return this._$translate.instant('LABEL_PAID');
                case Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum.PastDue:
                    return this._$translate.instant('LABEL_PAST_DUE');
                case Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum.Pending:
                    return this._$translate.instant('LABEL_PENDING');
                case Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum.Processing:
                    return this._$translate.instant('LABEL_PROCESSING');
                default:
                    return '';
            }
        }
    }


    angular.module('meevo.plugins.paymentPlans')
        .service('meevo.plugins.paymentPlans.PaymentPlansHelper', PaymentPlansHelper.factory());
}
